import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
// @ts-ignore
import {fadeInUp400ms} from '@vex/animations/fade-in-up.animation';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
// @ts-ignore
import {VexPageLayoutComponent} from '@vex/components/vex-page-layout/vex-page-layout.component';
// @ts-ignore
import {VexSecondaryToolbarComponent} from '@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
// @ts-ignore
import {VexBreadcrumbsComponent} from '@vex/components/vex-breadcrumbs/vex-breadcrumbs.component';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {ErrorStateMatcher, MatOptionModule, ShowOnDirtyErrorStateMatcher} from '@angular/material/core';
import {AsyncPipe, NgFor, NgIf, NgOptimizedImage} from '@angular/common';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {StorageService} from '../../shared/services/storage.service';
import {AuthService} from '../../shared/services/auth.service';
import {GlobalService} from '../../shared/services/global.service';
import {UserService} from '../../shared/services/user.service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {AlertService} from '../../shared/services/alert.service';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {HeaderComponent} from "../../landing/header/header.component";
import {FooterComponent} from "../../landing/footer/footer.component";
import {SharedModule} from "../../shared/shared.module";

@Component({
  selector: 'vex-login',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatCheckboxModule,
    VexPageLayoutComponent,
    VexSecondaryToolbarComponent,
    VexBreadcrumbsComponent,
    MatIconModule,
    VexBreadcrumbsComponent,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgIf,
    ReactiveFormsModule,
    NgFor,
    MatSlideToggleModule,
    MatTooltipModule,
    NgOptimizedImage,
    MatAutocompleteModule,
    AsyncPipe,
    HeaderComponent,
    FooterComponent,
    SharedModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ],
  providers: [
    GlobalService,
    AuthService,
    UserService,
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher}
  ]
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup = new FormGroup({});
  signInForm: FormGroup = new FormGroup({});
  //otpForm: FormGroup = new FormGroup({});
  inputType: any = 'password';
  visible: any = false;
  submitted: any = false;
  isBusy: any = false;
  organisations: any = [];
  formType: string = 'login';
  signInParams: any = {};
  userImageUrl: string;
  is_submitting: boolean = false;
  myControl: FormControl = new FormControl('');
  pageExtras: {} = {
    'buttonType': 'search',
    'imageUrl': '',
    'profileImage': ''
  }

  constructor(private router: Router,
              private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private authService: AuthService,
              private userService: UserService,
              private globalService: GlobalService,
              private route: ActivatedRoute,
              private alertService: AlertService
  ) {
    this.checkLogin();
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    if (this.router.url.includes('/register')) this.formType = 'signIn';

    this.loginForm = this.fb.group({
      'username': ['', [Validators.required, Validators.minLength(6), Validators.maxLength(8)]],
      'password': ['', [Validators.required, Validators.minLength(6)]]
    });
    this.signInForm = this.fb.group({
      'name': ['', Validators.required],
      'email': ['', [Validators.required, Validators.email]],
      'contact': ['', Validators.required],
      'username': ['', [Validators.required, Validators.minLength(6), Validators.maxLength(8)]],
      'password': ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  checkLogin(): void {
    if (StorageService.getItem('accessToken') && StorageService.getItem('self')) {
      this.globalService.setAccessToken(StorageService.getItem('accessToken'));
      this.globalService.setSelf(StorageService.getItem('self'));
      this.reloadSelf();
    } else {
      // this.router.navigateByUrl('auth/login');
    }
  }

  reloadSelf(): void {
    this.authService.self().subscribe((data) => {
      this.globalService.setSelf({
        name: data?.name,
        email: data?.email,
        contact: data?.contact,
        user_id: data?._id,
        username: data?.username,
        userType: data?.userType
      });
      this.router.navigateByUrl('/home');
    }, e => {
      StorageService.clearAll();
      this.router.navigateByUrl('auth/login');
    });
  }

  login(): void {
    this.submitted = true;
    if (!this.loginForm.valid) {
      return;
    }
    if (this.submitted) {
      if (this.checkLoggedInStatus()) {
        this.setSelfData();
        this.router.navigateByUrl('/home');
      } else {
        let params: {} = {
          username: (this.loginForm.getRawValue() && this.loginForm.getRawValue().username) ? this.loginForm.getRawValue().username : '',
          password: (this.loginForm.getRawValue() && this.loginForm.getRawValue().password) ? this.loginForm.getRawValue().password : ''
        };
        this.authService.login(params).subscribe(data => {
          if (data && data.accessToken) {
            this.globalService.setAccessToken(data?.accessToken);
            this.globalService.setSelf({
              name: data?.userDetails?.name,
              email: data?.userDetails?.email,
              contact: data?.userDetails?.contact,
              userId: data?.userDetails?._id,
              username: data?.userDetails?.username,
              userType: data?.userDetails?.userType
            });
            this.router.navigateByUrl('/home');
            this.loginForm.reset();
          }
        }, error => {
          this.isBusy = false;
          this.submitted = false;
          this.alertService.showErrors(error.error.message)
        });
      }
    }
  }

  register() {
    this.submitted = true
    if (!this.signInForm.valid) {
      return
    }

    let params = {
      name: (this.signInForm && this.signInForm.getRawValue() && this.signInForm.getRawValue().name) || '',
      email: (this.signInForm && this.signInForm.getRawValue() && this.signInForm.getRawValue().email) || '',
      contact: (this.signInForm && this.signInForm.getRawValue() && this.signInForm.getRawValue().contact) || '',
      username: (this.signInForm && this.signInForm.getRawValue() && this.signInForm.getRawValue().username) || '',
      password: (this.signInForm && this.signInForm.getRawValue() && this.signInForm.getRawValue().password) || ''
    }

    this.authService.register(params).subscribe(data => {
      if (data && data.accessToken) {
        this.globalService.setAccessToken(data?.accessToken);
        this.globalService.setSelf({
          name: data?.userDetails?.name,
          email: data?.userDetails?.email,
          contact: data?.userDetails?.contact,
          userId: data?.userDetails?._id,
          username: data?.userDetails?.username,
          userType: data?.userDetails?.userType
        });
        this.router.navigateByUrl('/home');
        this.signInForm.reset();
      }
    }, error => this.alertService.showErrors(error.error.message))
  }

  checkLoggedInStatus() {
    const accessToken = StorageService.getItem('accessToken');
    return accessToken && accessToken !== 'null';
  }

  setSelfData(): void {
    this.authService.self().subscribe((data) => {
      this.isBusy = false;
      this.globalService.setSelf({
        name: data?.name,
        email: data?.email,
        contact: data?.contact,
        userId: data?._id,
        username: data?.username,
        userType: data?.userType
      });
      return;
    }, e => {
      this.isBusy = false;
      StorageService.clearAll();
    });
  }

  toggleVisibility(): void {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
